import React from 'react';

const FullPageLoader: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative z-10 loader-content">
        <div className="loader-icon">
          <svg className="animate-spin" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="45" fill="none" stroke="#6e45e9" strokeWidth="8" strokeDasharray="70 30">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 50 50"
                to="360 50 50"
                dur="2s"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="50" cy="50" r="35" fill="none" stroke="#00d2e1" strokeWidth="6" strokeDasharray="55 45" strokeDashoffset="25">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 50 50"
                to="-360 50 50"
                dur="1.5s"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="50" cy="50" r="25" fill="none" stroke="#d612fc" strokeWidth="4" strokeDasharray="40 60" strokeDashoffset="50">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 50 50"
                to="360 50 50"
                dur="1s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </div>
        <div className="loader-text animate-pulse">Generating Your SEO Report</div>
        <div className="loader-subtext">Please wait while we analyze your results...</div>
      </div>
    </div>
  );
};

export default FullPageLoader;